var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic-card",style:({ backgroundImage: `url(${_vm.image})` })},[_c('div',[_c('p',{staticClass:"topic-index"},[_vm._v("Topic "+_vm._s(_vm.index + 1))]),_c('h3',{staticClass:"topic-title"},[_vm._v(_vm._s(_vm.title))])]),_c('p',{staticClass:"topic-description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }